import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=6030c81e"
import script from "./Greetings.vue?vue&type=script&lang=js"
export * from "./Greetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports